import { makeAutoObservable } from 'mobx'
import { Place } from 'infra/type'

class PlaceMarkersCacheStore {
  data: Map<Number, Place> = new Map()

  constructor() {
    makeAutoObservable(this)
  }

  remove(place: Place) {
    this.data.delete(place.id)
  }

  save(places: Place[]) {
    places.forEach((p) => {
      this.data.set(p.id, p)
    })
  }

  get places(): Place[] {
    return Array.from(this.data.values())
  }
}

// 장소 데이터는 처음에 한번에 PlacesStore 에서 가져오고
// 지도에 보여주는 건 필요한 만큼만 점진적으로 보여준다
export const placeMarkersCacheStore = new PlaceMarkersCacheStore()
